export const BRAND = {
  name: "SAMIJ SWEETS",
  phones: ["8486506625", "6003888971"],
  address: "Opposite N.M.H.S. School, Banskandi",
  hours: "5:00 AM – 9:00 PM",
  hoursShort: "5 AM – 9 PM",
  owner: "Bappu",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent("N.M.H.S. School, Banskandi, Assam"),
};

export const IMAGES = {
  heroMain: "/photos/mithai-box.webp",
  heroOverlap: "/photos/platter-single.jpg",
  aboutShop: "/photos/shop-counter.jpg",
  jilebi: "/photos/jilebi.jpg",
  rasmalai: "/photos/rasmalai.jpg",
  boondi: "/photos/boondi.jpg",
  rasgulla: "/photos/rasgulla.jpg",
  celebration: "/photos/platters.jpg",
  morningCounter: "/photos/display-counter.jpg",
  dahi: "/photos/dahi.jpg",
};

export const NAV_LINKS = [
  { label: "Home", hash: "#home", id: "home" },
  { label: "Menu", hash: "#menu", id: "menu" },
  { label: "Specialties", hash: "#specialties", id: "specialties" },
  { label: "About Us", hash: "#about", id: "about" },
  { label: "Contact & Location", hash: "#contact", id: "contact" },
];

export const MENU = [
  {
    num: "01",
    title: "Morning Breakfast & Specials",
    note: "Hot from the kadhai, every day from 5 AM",
    items: [
      {
        name: "Samosa",
        price: "₹10",
        unit: "piece",
        desc: "Crispy, golden, and freshly fried",
        tag: "Fried fresh daily",
      },
      {
        name: "Roti & Bogni Plate",
        price: "₹30",
        unit: "plate",
        desc: "Served piping hot",
        tag: "Morning favourite",
      },
    ],
  },
  {
    num: "02",
    title: "Beverages & Juices",
    note: "Freshly squeezed, served chilled",
    items: [
      { name: "Juice — Large", price: "₹110", unit: "glass", desc: "Fresh fruit juice, made on order" },
      { name: "Juice — Small", price: "₹50", unit: "glass", desc: "Fresh fruit juice, made on order" },
    ],
  },
  {
    num: "03",
    title: "Traditional Sweets & Pure Ghee Delicacies",
    note: "The heart of our counter — khoya, paneer & pure desi ghee",
    items: [
      {
        name: "Assorted Mithai (Pure)",
        price: "₹10–₹20",
        unit: "piece",
        desc: "Pricing varies — select items available at ₹10, ₹15 and ₹20",
        tag: "Best value",
        ladder: true,
        img: IMAGES.rasgulla,
      },
      {
        name: "Pure Desi Ghee Jilebi (Geer Jilebi)",
        price: "Ask",
        unit: "at counter",
        desc: "Golden spirals soaked sweet — our house signature",
        img: IMAGES.jilebi,
      },
      {
        name: "Pure Paneer Sweets",
        price: "Ask",
        unit: "at counter",
        desc: "Soft milk-based classics, made fresh daily",
        img: IMAGES.rasmalai,
      },
      {
        name: "Pure Desi Ghee Mithai Collection",
        price: "Ask",
        unit: "at counter",
        desc: "The full ghee-rich halwai spread, by the piece or by the box",
        img: IMAGES.boondi,
      },
    ],
  },
  {
    num: "04",
    title: "Savory Snacks & Namkeen",
    note: "Crunchy companions for chai and celebrations",
    items: [
      { name: "Geer Nimki (Pure)", price: "Ask", unit: "at counter", desc: "Crisp, ghee-made, impossible to stop at one" },
      { name: "Bhujia & Bundia Namkeen", price: "Ask", unit: "at counter", desc: "Crunchy, spiced, packed fresh" },
    ],
  },
];

export const SPECIALTIES = [
  {
    numeral: "I",
    title: "Morning Special Combo",
    desc: "Hot Samosa paired with fresh morning juice — the Banskandi breakfast regulars swear by.",
    img: IMAGES.morningCounter,
    alt: "The bright morning counter at Samij Sweets",
    tag: "Available from 5:00 AM",
  },
  {
    numeral: "II",
    title: "Dahi",
    desc: "Sweet dahi cups, set fresh and topped with raisins & cashew — a cooling classic at our counter.",
    img: IMAGES.dahi,
    alt: "Cups of fresh dahi topped with raisins and cashew",
    tag: "Everyday favourite",
  },
  {
    numeral: "III",
    title: "Celebration Box",
    desc: "A curated mix of pure ghee sweets, geer jilebi, and premium namkeen — dressed for gifting.",
    img: IMAGES.celebration,
    alt: "Celebration platters of assorted mithai wrapped and ready",
    tag: "Made to order",
  },
];

export const MARQUEE_ITEMS = [
  "Pure Desi Ghee",
  "মিষ্টি",
  "Geer Jilebi",
  "Hot Samosa from 5 AM",
  "Fresh Roti & Bogni",
  "Paneer Sweets",
  "Geer Nimki",
  "Celebration Boxes",
];
